// extracted by mini-css-extract-plugin
export default {"container":"yQ-z","topReviewHeading":"zQ-z","criticalReview":"AQ-z","favorableReview":"BQ-z","vsSeparator":"CQ-z"};